import * as pathToRegexp from 'path-to-regexp';
import { ClassAttributes, createElement, FC } from 'react';
import ReactDocumentTitle from 'react-document-title';

import { Consumer as StateConsumer } from '../context/state';

type Props = ClassAttributes<HTMLElement>;

const DocumentTitle: FC<Props> = () => (
  <StateConsumer>
    {state => {
      const location = state.location;
      let title: string | null = null;

      if (location.pathname === '/settings') {
        title = 'Settings';
      } else if (pathToRegexp('/creations/:creationId').test(location.pathname)) {
        title = 'Loading...';
      }

      if (title === null) {
        title = 'Kaizen Platform';
      } else {
        title = `${title} | Kaizen Platform`;
      }

      return <ReactDocumentTitle title={title} />;
    }}
  </StateConsumer>
);

export default DocumentTitle;
